import React, { useState } from 'react';

const defaultValue = {
  produtos: [],
  produtoAtual: {},
  selecao: [],
  tipoSelecao: 'NENHUM',
  loading: false,
  totalElements: 0,
  modal: '',
  search: '',
  page: 0,
  size: 15,
  sort: 'nome,ASC',
  filtroAvancado: {}
};

export const ProdutoContext = React.createContext({});

export const ProdutoProvider = (props) => {
  return (
    <ProdutoContext.Provider
      value={{
        produtos: useState(defaultValue.produtos),
        produtoAtual: useState(defaultValue.produtoAtual),
        selecao: useState(defaultValue.selecao),
        tipoSelecao: useState(defaultValue.tipoSelecao),
        loading: useState(defaultValue.loading),
        totalElements: useState(defaultValue.totalElements),
        modal: useState(defaultValue.modal),
        search: useState(defaultValue.search),
        page: useState(defaultValue.page),
        size: useState(defaultValue.size),
        sort: useState(defaultValue.sort),
        filtroAvancado: useState(defaultValue.filtroAvancado),
      }}
    >
      {props.children}
    </ProdutoContext.Provider>
  );
};

export const ProdutoConsumer = ProdutoContext.Consumer;
